import { TableContainer } from "./styles";
import { baseURL } from "../../../../../services/api";
import Lixeira from "../../../../../assets/excluir.svg"
import Liberar from "../../../../../assets/liberar.svg"
import { ReactSVG } from "react-svg";
import { useAuth } from "../../../../../providers/Auth";
import { useState } from "react";
import { ModalRemoverVisualizacaoCriativoMensagem } from "../../../../Modal/RemoverVizualizacaoMensagemCriativo";
import { ModalReativarVisualizacaoCriativoMensagem } from "../../../../Modal/ReAbrirMensagem";

const Table = ({ mensagens, buscarCriativo }) => {
  const { user } = useAuth()
  const colunas = ["Tipo do Assunto", "Comentário", "Pontos", "Prazo Estimado", "Responsável", "Data e Hora"];
  const [criativoMensagemSelecionado, setCriativoMensagemSelecionado] = useState(false)

  return (
    <TableContainer>
      <table>
        <thead>
          <tr>
            {colunas.map((coluna) => (
              <th key={coluna} className={coluna == "Comentário" ? "text-start" : coluna == "Tipo do Assunto" ? "minWidth150" : ""}>{coluna}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {mensagens.map((criativo) => (
            <tr className="map" key={criativo.id}>
              <td className="text-start">{criativo.tipo}</td>
              <td className="text-start">
                {criativo.comentario}
                <div className="arquivos">
                  {
                    criativo.arquivos.map((arquivo) => {
                      if (!arquivo) {
                        return
                      }

                      return (
                        ['.jpeg', '.png', '.jpg'].includes(arquivo.substring(arquivo.indexOf('.'))) ?
                          <div className="relative">
                            {/* <span onClick={() => deletarArquivo(arquivo.nome_arquivo)}>X</span> */}
                            <a href={`${baseURL}/uploads/${arquivo}`} target="_blank">
                              <img className="images" src={`${baseURL}/uploads/${arquivo}`} />
                            </a>
                          </div>
                          :
                          <a href={`${baseURL}/uploads/${arquivo}`} download={arquivo} target="_blank">{arquivo.slice(16, 46)}</a>
                      )
                    }
                    )
                  }
                </div>
              </td>
              <td>{criativo?.pontos}</td>
              <td>{criativo?.prazo_estimado?.split("-")?.reverse()?.join("/")}</td>
              <td>{criativo.nome_responsavel} {criativo.sobrenome_responsavel}</td>
              <td>{criativo.data_criacao}</td>
              {
                user.perfil.includes("administrador") && criativo.status === 1 &&
                < td className="excluir">
                  <ReactSVG className="excluir" src={Lixeira} onClick={() => setCriativoMensagemSelecionado({ ...criativo, acao: "remover" })} />
                </td>
              }
              {
                user.perfil.includes("administrador") && criativo.status === 0 &&
                < td className="excluir">
                  <ReactSVG className="excluir verde" src={Liberar} onClick={() => setCriativoMensagemSelecionado({ ...criativo, acao: "reabrir" })} />
                </td>
              }
            </tr>
          ))}
        </tbody>
      </table>
      {
        criativoMensagemSelecionado?.acao === "remover" &&
        <ModalRemoverVisualizacaoCriativoMensagem
          state={setCriativoMensagemSelecionado}
          criativoMensagem={criativoMensagemSelecionado}
          buscarCriativo={buscarCriativo}
        />
      }
      {
        criativoMensagemSelecionado?.acao === "reabrir" &&
        <ModalReativarVisualizacaoCriativoMensagem
          state={setCriativoMensagemSelecionado}
          criativoMensagem={criativoMensagemSelecionado}
          buscarCriativo={buscarCriativo} />
      }
    </TableContainer >
  );
};

export default Table;
